<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-input ttRememberId="w_travelwages.filtervalue" ttLabel="filtervalue" ttFocus="true" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
            <tt-button-goto ttText="travelwages_new" ttGoto="travelwage" [ttGotoParms]="{ travelwage_id: '+' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListTravelWages" [ttFilter]="setting.filtervalue"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <tt-input ttRememberId="w_travelwages.filtervalue" ttLabel="filtervalue" ttFocus="true" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button-goto ttText="travelwages_new" ttGoto="travelwage" [ttGotoParms]="{ travelwage_id: '+' }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>
        </div>

        <tt-list class="col-xs-12 col-md-4 p-5" [ttData]="itemsListTravelWages" [ttFilter]="setting.filtervalue"></tt-list>
    </div>
</tt-page>
